<template>
  <div class="content-section" id="tech-projects">
    <section-title>Projects</section-title>
    <div class="content-section__body">
      <v-row align="start" justify="center">
        <v-col cols="11" sm="10" md="6">
          <tech-projects-card
            v-for="(proj, index) in projectsColumn1"
            :key="index"
            :title="proj.title"
            :description="proj.description"
            :screenshot_path="proj.screenshot_path"
            :links="proj.links"
            :stacks_used="proj.stacks_used"
          />
        </v-col>

        <v-col cols="11" sm="10" md="6">
          <tech-projects-card
            v-for="(proj, index) in projectsColumn2"
            :key="index"
            :title="proj.title"
            :description="proj.description"
            :screenshot_path="proj.screenshot_path"
            :links="proj.links"
            :stacks_used="proj.stacks_used"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import portfolioData from 'data/dev-portfolio.json';
import SectionTitle from '@/components/utilities/SectionTitle';
import TechProjectsCard from '@/components/home/contents/TechProjectsCard';

export default {
  name: 'TechProjects',

  components: {
    SectionTitle,
    TechProjectsCard,
  },

  data: () => ({
    projects: portfolioData.projects,
  }),

  computed: {
    projectsColumn1() {
      return this.projects.filter((_, i) => i % 2 === 0);
    },
    projectsColumn2() {
      return this.projects.filter((_, i) => i % 2 !== 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.stack-icon {
  font-size: 2em;
  padding: 2px 4px;
}

.working-app__btn {
  margin-left: 5px;
  color: white;
}

.source-code__btn {
  color: darkslategrey;
}

.project-card {
  margin-bottom: 10px;
}
</style>
